<template>
     <transition 
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut">
        <div v-show ="show" class = "notification__zone_sub-wrapper">
            <div class="notification_order-title">
                <div class = "notification_order-title-status">{{typeOrder}}</div>
                <div class = "notification_order-title-pair">{{positionData.symbol}}</div>
                <div class = "notification_order-title-number">{{positionData.id}}</div>
                <div class = "notification_order-title-day">{{getDate}}</div>
                <div class = "notification_order-title-time">{{$datef(positionData.timeEnter, 't')}}</div>
                <i @click="closeNoti" class="mdi mdi-window-close"></i>
            </div>
            <div class="notification_order-main_data">
                <div class="notification_order-main_data-type_and_volume notification_order-block_big">
                    <div class="notification_order-main_data-type_and_volume-img"><i :class="positionData.side < 0 ? 'icon-bear':'icon-bull'"></i></div>
                    <div class="notification_order-main_data-type_and_volume-data">
                        <div class="notification_order-sub-title">тип и объём</div>
                        <div class="notification_order-main_data-type_and_volume-data-type">
                            <div class="notification_order-sub-data"
                            :class="positionData.side < 0 ? 'color-red': 'color-green'">{{
                                positionData.side < 0 ? 'SELL' : 'BUY'
                            }}</div>
                            <div class="notification_order-sub-data">{{$moneyf(positionData.volume)}}</div>
                        </div>
                    </div>
                </div>
                <div class = "notification_order-main_data-price_open notification_order-block_midle">
                    <div class="notification_order-sub-title">Цена</div>
                    <div class="notification_order-sub-data">{{positionData.priceEnter}}</div>
                </div>
                <div class = "notification_order-main_data-price_sl notification_order-block_midle">
                    <div class="notification_order-sub-title">S/L</div>
                    <div class="notification_order-sub-data">{{positionData.sl}}</div>
                </div>
                <div class="notification_order-main_data-price_tp notification_order-block_midle">
                    <div class="notification_order-sub-title">T/P</div>
                    <div class="notification_order-sub-data">{{positionData.tp}}</div>
                </div>
            </div>
        </div>
     </transition>
</template>
<script>
export default {
    data() {
        return {
            show:true
        }
    },
    props : {
        positionData: {default:{}}
    },
    computed :{ 
        getDate() {
            let date = this.$datef(this.positionData.timeEnter, 'd');
            return date;
        }
    },
    methods : {
        closeNoti() {
            this.show = false;
        }
    }
}
</script>
<style lang="less" scoped>
.notification__zone {
    &_sub-wrapper {
        background-color:rgb(255, 254, 204);;
        border-radius: 4px;
        display: block;
        margin: 12px 12px;
        width: 370px;
        box-shadow: 0 0 10px rgba(0,0,0,0.3);
    }
}

.notification_order {
    &-title {
        display: flex;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        height: 30px;
        align-items: center;
        letter-spacing: 0.4px;
        text-align: left;
        color: #000;
        text-transform: uppercase;
        border-bottom: 1px solid #374b62;
        i {
            font-size: 14px;
            margin-left: auto;
            cursor: pointer;
            margin-right: 4px;
        }
        &-status {
            margin-left: 12px;
        }
        &-pair {
            margin-left: 12px;
        }
        &-number {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-day {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-time {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
    }
    &-main_data {
        display: flex;
        padding: 4px 0;
        /*border-bottom: 1px solid #374b62;*/

        &-type_and_volume {
            display: flex;
            &-data-type {
                display: flex;
            }
            &-img {
                font-size:32px;
                color:#000;
            }
            &-data {
                margin-left: 8px;
            }
        }
    }
    &-sub-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: 0.4px;
        color: #7a8088;
        text-transform: uppercase;
    }
    &-sub-data {
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.23;
        letter-spacing: 0.4px;
        text-align: left;
        color: #000;
        margin-right: 4px;
    }
    &-block_big {
        width: 176px;
        padding-left: 12px;
        box-sizing: border-box;
    }
    &-block_midle {
        width: 88px;
        padding-left: 12px;
        box-sizing: border-box;
    }
}
</style>
